import React from "react";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { useProSidebar } from "react-pro-sidebar";
import { HiMenuAlt2 } from "react-icons/hi";

const TopNav = () => {
    const { toggleSidebar } = useProSidebar();
    const { user } = useProtectedRoutesContext();


    return (
        <>
            <div className=" bg-white border-b border-b-[#cfcfcf] flex items-center justify-between py-[1rem]  lg:py-[1.7rem]">
                <div
                    className="cursor-pointer min-[1000px]:hidden"
                    onClick={() => toggleSidebar()}
                >
                    <HiMenuAlt2 size="2.5rem" className="text-lightText" />
                </div>

                <p className="text-[1.8rem] font-medium">Hello {user?.name}</p>

            </div>


        </>
    );
};

export default TopNav;
